import React from "react";
import "./App.css";
import FormInput from "./FormInput";
function App() {
  return (
    <div className="App">
      <FormInput />
    </div>
  );
}

export default App;
